import React, { useState } from "react";
import styled from "styled-components";
import CategoryQuery from "components/pages/category/CategoryQuery";
import CategoryStoriesQuery from "components/pages/category/CategoryStoriesQuery";
import ApiCategory from "models/data/api/ApiCategory";
import { FooterWithState } from "components/Footer";
import StoriesListLoader from "components/shared/spinners/StoriesListLoader";
import { useRouter } from "next/router";
import PageContainer from "components/containers/PageContainer";
import withApollo from "components/higher-order/withApollo";
import { getNumStories } from "data/api/ApiCategory";
import { useRecordPageView } from "hooks/analytics/useRecordPageView";
import { StoryList } from "components/shared/StoryList";
import { CategoryMetaTags } from "components/shared/MetaTags/MetaTags";
import { baseUrl } from "services/shared/Environment";
import StoriesListContainer from "components/shared/containers/StoriesListContainer";

const Title = styled.h1`
  font-family: ${(props) => props.theme.fonts.poppins};
`;

const CategoryPageContainer = styled.div`
  min-height: 100vh;
`;

const HtmlContainer = styled.div.attrs({ className: "w-full" })`
  ${({ theme }) => `
      p {
        margin:15px 0 10px;
      }
      a {
        color: ${theme.colors.orange}
      }
      max-width: 1000px;
      margin: 0px auto;
  `}
`;

function CategoryPage() {
  const {
    query: { slug: routerSlug },
    asPath,
  } = useRouter();
  //cast type bc we know slug will only have one value, and therefore will be type 'string' and not 'string[]'
  const slug: any = routerSlug;
  const url = `${baseUrl()}${asPath}`;

  const [numStoriesShown, setNumStoriesShown] = useState(10);

  useRecordPageView();

  return (
    <>
      <CategoryMetaTags categorySlug={slug} categoryUrl={url} />
      <PageContainer>
        <CategoryPageContainer>
          <CategoryQuery categorySlug={slug}>
            {({ category }) => (
              <>
                <div className="w-full flex items-center justify-center py-6 px-6">
                  <Title className="font-bold text-3xl">
                    {ApiCategory.title(category)}
                  </Title>
                </div>
                <div className="text-left mb-6 mx-8 flex justify-center">
                  <HtmlContainer
                    dangerouslySetInnerHTML={{
                      __html: ApiCategory.descriptionHtml(category),
                    }}
                  ></HtmlContainer>
                </div>
                <div className="w-full h-px bg-gray-400 mb-6" />
                <CategoryStoriesQuery
                  numStories={numStoriesShown}
                  categoryId={category.id}
                >
                  {({ stories, loading }) => (
                    <StoriesListContainer>
                      <StoryList stories={stories} />
                      {getNumStories(category) > numStoriesShown && (
                        <StoriesListLoader
                          loading={loading}
                          onClickLoad={() =>
                            setNumStoriesShown(numStoriesShown + 10)
                          }
                        />
                      )}
                    </StoriesListContainer>
                  )}
                </CategoryStoriesQuery>
                {ApiCategory.longDescriptionHtml(category) !== "" && (
                  <div className="text-left text-base mb-16 mx-8 -mt-2 flex-col justify-center">
                    <h2 className="text-left text-base mb-12 flex font-bold justify-center">
                      <a className="underline" href="/subscribe">
                        {" "}
                        Subscribe{" "}
                      </a>
                      &nbsp; for more smart, nuanced, in-depth South Asian
                      stories.
                    </h2>
                    <HtmlContainer
                      dangerouslySetInnerHTML={{
                        __html: ApiCategory.longDescriptionHtml(category),
                      }}
                    ></HtmlContainer>
                  </div>
                )}
              </>
            )}
          </CategoryQuery>
        </CategoryPageContainer>
        <FooterWithState />
      </PageContainer>
    </>
  );
}

export default withApollo(CategoryPage);
